<header>
    <h2>Create Task</h2>
</header>


<div class="container">

    <ng-template cdkConnectedOverlay (backdropClick)="close()" (detach)="close()"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayOffsetY]="-150">
        <div class="customer-search mat-elevation-z10">
            <mat-form-field class="search" appearance="outline">
                <mat-label>Search</mat-label>
                <input placeholder="type name/phone" (keyup)="findCustomers(searchText.value)" matInput #searchText
                    value="">
            </mat-form-field>

            <div>
                <div *ngFor="let customer of customers">
                    <button mat-button (click)="pickCustomer(customer)">{{customer.name}}</button> -- <span [apPhone]="customer.phone">{{customer.phone | phone}}</span>
                </div>
            </div>

            <div>
                <button (click)="createCustomer()" *ngIf="!searchText.value" mat-stroked-button color="primary">Create a new
                    customer</button>
                <button (click)="createCustomer(searchText.value)" *ngIf="searchText.value" mat-stroked-button
                    color="primary">Create {{searchText.value}} as new customer</button>
            </div>
        </div>
    </ng-template>

    <div [class.hidden]="hasCustomer()" class="pick-customer">
        <button (click)="isOpen = !isOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin" matRipple apStatus="Add a customer to this invoice" accent="" mat-raised-button><mat-icon>person_add</mat-icon> Add a customer</button>
    </div>

    <div *ngIf="hasCustomer()" class="customer">

        <div>{{newTask.customer?.name}}</div>
        <div><span [apPhone]="newTask.customer?.phone">{{newTask.customer?.phone | phone}}</span></div>

        <button (click)="editCustomer()" mat-button>Edit</button><button (click)="chooseDifferentCustomer()" mat-button>Choose a different Customer</button>
    </div>

<!--
    <div>
        <mat-form-field appearance="outline">
            <mat-label>Subject</mat-label>
            <input [(ngModel)]="newTask.subject" matInput placeholder="...">
        </mat-form-field>
    </div> -->

    <div>
        <ap-money mat-input class="quote" matInput [(amount)]="newTask.quote"></ap-money>

    </div>

    <mat-form-field class="description" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea [(ngModel)]="newTask.description" matInput></textarea>
    </mat-form-field>

    <div>
      <button (click)="createTask()" color="primary" mat-raised-button>Create Task</button>
    </div>

</div>
